import { applyMiddleware, compose, createStore } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import thunk from 'redux-thunk';
import createRootReducer from '../reducers';

function configureStoreProd(initialState) {
	const middlewares = [
		// Add other middleware on this line...
		// thunk middleware can also accept an extra argument to be passed to each thunk action
		// https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
		thunk,
	];

	const persistConfig = {
		key: 'root',
		storage,
	};

	const persistedReducer = persistReducer(persistConfig, createRootReducer());

	let store = createStore(persistedReducer, initialState, compose(applyMiddleware(...middlewares)));
	let persistor = persistStore(store);

	return { store, persistor };
}

function configureStoreDev(initialState) {
	const middlewares = [
		// Add other middleware on this line...

		// Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
		reduxImmutableStateInvariant(),

		// thunk middleware can also accept an extra argument to be passed to each thunk action
		// https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
		require('redux-immutable-state-invariant').default(),
		thunk,
	];

	const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
	const persistConfig = {
		key: 'root',
		storage,
	};

	const persistedReducer = persistReducer(persistConfig, createRootReducer());

	let store = createStore(persistedReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('../reducers', () => {
			const nextReducer = require('../reducers').default; // eslint-disable-line global-require
			store.replaceReducer(nextReducer);
		});
	}

	let persistor = persistStore(store);

	return { store, persistor };
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
